import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { Card, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router";
import { ContainerGrid, HeaderLayout } from "../../components";

interface IProps {
  children?: React.ReactNode;
  faded?: boolean;
  title?: string;
  actions?: React.ReactNode;
  sideBarContent?: React.ReactNode;
}

const DetailPageLayout = (props: IProps) => {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <HeaderLayout
      title={
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="row" spacing={1} alignItems="center">
            {window.history.length > 1 && (
              <IconButton variant="tertiary" onClick={() => navigate(-1)}>
                <ArrowBackIosNewRoundedIcon />
              </IconButton>
            )}

            {props.title && <Typography variant="h6">{props.title}</Typography>}
          </Stack>

          {props.actions}
        </Stack>
      }
    >
      <ContainerGrid container spacing={1}>
        <ContainerGrid size={{ xs: 12, md: 8 }} offset={{ md: 2 }}>
          <Card sx={{ background: props.faded ? theme.palette.grey[100] : undefined }}>{props.children}</Card>
        </ContainerGrid>

        {props.sideBarContent && !props.faded && (
          <ContainerGrid size={{ xs: 12, md: 4 }}>{props.sideBarContent}</ContainerGrid>
        )}
      </ContainerGrid>
    </HeaderLayout>
  );
};

export { DetailPageLayout };
